<template>
	<svg
		class="anim-rotate-infinite"
		:width="size"
		:height="size"
		viewBox="0 0 120 120"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M68.3198 15.3841C68.7645 12.9451 67.1474 10.5861 64.6783 10.3619C54.722 9.45769 44.6843 11.5576 35.884 16.4442C25.7708 22.0599 17.9176 31.0084 13.6626 41.7652C9.40751 52.5219 9.01385 64.4213 12.5486 75.4358C16.0834 86.4502 23.328 95.8983 33.0479 102.17C42.7679 108.442 54.3618 111.15 65.8542 109.831C77.3466 108.513 88.0265 103.251 96.0741 94.9417C104.122 86.6321 109.039 75.7892 109.988 64.2604C110.814 54.2284 108.591 44.2173 103.665 35.5181C102.443 33.3608 99.6273 32.8595 97.5883 34.2698C95.5492 35.68 95.0637 38.4667 96.2428 40.6475C100.011 47.6179 101.696 55.5628 101.041 63.5236C100.262 72.9822 96.2274 81.8782 89.6248 88.6957C83.0222 95.5132 74.2601 99.8305 64.8312 100.912C55.4024 101.993 45.8903 99.7719 37.9157 94.6262C29.9411 89.4805 23.9974 81.729 21.0973 72.6923C18.1972 63.6556 18.5202 53.8929 22.0112 45.0677C25.5022 36.2424 31.9453 28.9007 40.2425 24.2933C47.2259 20.4156 55.1592 18.6767 63.0631 19.2382C65.5361 19.4138 67.8751 17.8232 68.3198 15.3841Z"
			:fill="color"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		size: {
			type: Number,
			default: 32,
		},
		color: {
			type: String,
			default: '#0047ff',
		},
	},
};
</script>

<style>
.anim-rotate-infinite {
	animation: rotation 1s linear infinite;
}
</style>
